import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useSiteConfig } from "../context/SiteConfigContext";
import { CategoryContext } from "../context/CategoryContext";
import { Leaf, Phone, Sparkles, Info } from "lucide-react";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const USEFUL_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about-us" },
  { label: "Shop", to: "/shop" },
  { label: "Blogs", to: "/blog" },
  { label: "Contact Us", to: "/contact-us" },
];

// TODO: confirm actual routes — placeholders until you share the real slugs
const INFORMATION_LINKS = [
  { label: "Terms & Conditions", href: "/terms-and-conditions" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Return & Refund Policy", href: "/return-and-refund-policy" },
];

const Footer = () => {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <footer
      className="relative pt-16 pb-10 overflow-hidden"
      style={{ background: "var(--color-primary-dark)" }}
    >
   

      <div className="container mx-auto px-6 lg:px-14 relative z-10 text-white">
        {/* ════ MAIN GRID: 5 columns on desktop ════ */}
        <div className="ft-grid text-center lg:text-left">
          {/* ── 1: Useful Links ── */}
          <div className="flex flex-col items-center lg:items-start">
            <p className="ft-label">
              <Sparkles size={13} /> Useful Links
            </p>
            <ul className="flex flex-col items-center lg:items-start gap-[10px] list-none p-0 m-0">
              {USEFUL_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="ft-nav-link">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── 2: Information ── */}
          <div className="flex flex-col items-center lg:items-start">
            <p className="ft-label">
              <Info size={13} /> Information
            </p>
            <ul className="flex flex-col items-center lg:items-start gap-[10px] list-none p-0 m-0">
              {INFORMATION_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.href} className="ft-nav-link">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── 3: Logo (center) ── */}
          <div className="flex items-center justify-center lg:justify-start order-first lg:order-none sm:col-span-2 lg:col-span-1">
            <div className="   flex aspect-square w-[180px] lg:w-[190px] items-center justify-center rounded-full border-[6px] border-[var(--color-primary-dark)] bg-white p-4 shadow-[0_0_50px_rgba(166,60,6,0.5)]">
  <img src={config?.logo} alt="" className="  footer-logo-animation   h-full w-full object-contain" />
</div>
          </div>

          {/* ── 4: Categories ── */}
          <div className="flex flex-col items-center lg:items-start">
            <p className="ft-label">
              <Leaf size={13} /> Categories
            </p>
            <ul className="flex flex-col items-center lg:items-start gap-[10px] list-none p-0 m-0">
              {categories?.map((cat) => (
                <li key={cat?._id}>
                  <Link to={`/categories/${cat?.slugPath}`} className="ft-nav-link">
                    {cat?.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── 5: Get in Touch ── */}
          <div className="flex flex-col items-center lg:items-start">
            <p className="ft-label">
              <Phone size={13} /> Get in Touch
            </p>
            <div className="flex flex-col items-center lg:items-start gap-1.5">
              {/* <a href={config?.websiteUrl} className="ft-contact-link">
                {config?.websiteUrl}
              </a> */}
              <a href={`tel:${config?.phone}`} className="ft-contact-link">
                {config?.phone}
              </a>
            </div>

            <div className="flex gap-2.5 mt-4">
              {config?.socialMedia?.facebook && (
                <a href={config.socialMedia.facebook} target="_blank" rel="noreferrer" className="ft-social">
                  <FaFacebook size={16} />
                </a>
              )}
              {config?.socialMedia?.instagram && (
                <a href={config.socialMedia.instagram} target="_blank" rel="noreferrer" className="ft-social">
                  <FaInstagram size={16} />
                </a>
              )}
              {config?.socialMedia?.twitter && (
                <a href={config.socialMedia.twitter} target="_blank" rel="noreferrer" className="ft-social">
                  <FaTwitter size={16} />
                </a>
              )}
              {config?.socialMedia?.youtube && (
                <a href={config.socialMedia.youtube} target="_blank" rel="noreferrer" className="ft-social">
                  <FaYoutube size={16} />
                </a>
              )}
            </div>
          </div>
        </div>

        {/* ════ BOTTOM MARK ════ */}
        <div className="flex flex-col items-center border-t border-white/10 mt-14 pt-6">
          <span className="text-[0.55rem] uppercase tracking-[0.2em] text-white [font-family:var(--font-subheading)]">
          All Rights Reserved   © 2026 Annvanta.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;